import styled from '@emotion/styled';
import { Box } from '@mui/system';
import { Typography } from 'components/Typography';
import { pxToEm, theme } from 'theme';
import palette from 'theme/palette';

const ICON_SIZE = 45;

export const ScrollContainer = styled(Box)`
  display: flex;
  flex-wrap: nowrap;
  ${theme.breakpoints.down(1020)} {
    overflow-x: auto;
    column-gap: ${pxToEm(8)};
    padding: 0 16px;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;

export const Letter = styled(Typography)`
  font-weight: 400;
  color: ${palette.primary.main};
`;

export const Item = styled(Box, {
  shouldForwardProp: (prop) => !['unactive'].includes(String(prop)),
})<{ unactive: boolean; active: boolean }>`
  height: ${pxToEm(ICON_SIZE)};
  background-color: ${theme.palette.secondary.main};
  border-radius: ${pxToEm(10)};
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ unactive }) =>
    !unactive
      ? `
  cursor: pointer;
  &:hover {
    ${theme.breakpoints.up(768)} {
      background-color: ${theme.palette.grey['800']};
      ${Letter} {
        color: ${theme.palette.grey[300]};
      }
    }
  }`
      : `
  cursor: default;
  `}

  ${({ active }) =>
    active
      ? `
    background-color: ${theme.palette.grey['800']};
    ${Letter} {
      color: ${theme.palette.grey[300]} !important;
    }
  `
      : null}
  
  ${Letter} {
    color: ${({ unactive }) =>
      unactive ? theme.palette.grey[300] : theme.palette.primary.main};
  }
  ${theme.breakpoints.up(1020)} {
    flex-basis: calc((100% / 27) - 8px);
    flex-shrink: 0;
    margin: 0 0.25em;
  }
  ${theme.breakpoints.down(1020)} {
    width: ${pxToEm(ICON_SIZE)};
    flex: 0 0 auto;
  }
`;
